"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var styled_components_1 = __importStar(require("styled-components"));
var style_utils_1 = require("@nef/style-utils");
var ModalDialog = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1070;\n  display: none;\n  overflow: hidden;\n  outline: 0;\n\n  ", ";\n"], ["\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1070;\n  display: none;\n  overflow: hidden;\n  outline: 0;\n\n  ",
    ";\n"])), function (props) {
    return props.isOpen && styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      ", ";\n      ", ";\n      ", ";\n\n      -webkit-transform: translate(0, 0);\n      transform: translate(0, 0);\n    "], ["\n      ", ";\n      ", ";\n      ", ";\n\n      -webkit-transform: translate(0, 0);\n      transform: translate(0, 0);\n    "])), style_utils_1.setDisplay("flex"), style_utils_1.setJustifyContent("center"), style_utils_1.setAlignItems("center"));
});
exports.default = ModalDialog;
var templateObject_1, templateObject_2;
//# sourceMappingURL=index.js.map